
import { ClientDetails } from "@/components/clients/ClientDetails";

const ClientDetail = () => {
  return (
    <ClientDetails />
  );
};

export default ClientDetail;
